import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import classNames from 'classnames';
import ArrowLeftIcon from 'react-material-icons/icons/navigation/arrow-back';
import scrollWatcher from '@chama/ui-components/hocs/scroll-watcher';
import { HEADER_ID } from '@chama/ui-components/components/Header';
import './index.css';

const propTypes = {
  children: PropTypes.element,
  scrollTop: PropTypes.number.isRequired,
};

const defaultProps = {
  children: null,
};

class RightPanel extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      useAbsolutePositionSystem: !(CSS.supports && CSS.supports('position: sticky')),
      isFixed: false,
    };
  }

  handleRef = refName => {
    return ref => {
      this[refName] = ref;
    };
  };

  componentDidMount() {
    const headerHeight = document.getElementById(HEADER_ID).offsetHeight;
    const { top } = this.fixedWrapper.getBoundingClientRect();
    const wrapperOffset = top + this.props.scrollTop - headerHeight;
    const margin = 15;

    this.scrollLimit = headerHeight + wrapperOffset - margin;
  }

  componentWillReceiveProps(nextProps) {
    const { scrollTop } = nextProps;
    const { isFixed, useAbsolutePositionSystem } = this.state;

    if (scrollTop >= this.scrollLimit && scrollTop !== this.props.scrollTop) {
      if (!isFixed) {
        this.setState({ isFixed: true });
      }

      if (useAbsolutePositionSystem) {
        this.fixedWrapper.style.top = `${scrollTop - this.scrollLimit}px`;
      }
    } else if (scrollTop < this.scrollLimit && scrollTop !== this.props.scrollTop) {
      if (isFixed) {
        this.setState({ isFixed: false });
      }

      if (useAbsolutePositionSystem) {
        this.fixedWrapper.style.top = '0px';
      }
    }
  }

  renderContent = () => {
    const { children } = this.props;
    const { isFixed } = this.state;

    if (children) {
      return React.cloneElement(children, { isFixed });
    }

    return (
      <div className="OrderDetailsLayout__no_order_panel">
        <ArrowLeftIcon />
        <div className="OrderDetailsLayout__no_order_text">
          <FormattedMessage
            id="orderdetails_none_selected"
            defaultMessage="Please select an order on the left"
          />
        </div>
      </div>
    );
  };

  render() {
    const { isFixed, useAbsolutePositionSystem } = this.state;
    const wrapperClass = classNames('RightPanel__wrapper', {
      'RightPanel__wrapper--sticky': !useAbsolutePositionSystem,
      'RightPanel__wrapper--fixed': isFixed,
    });

    return (
      <div ref={this.handleRef('fixedWrapper')} className={wrapperClass}>
        {this.renderContent()}
      </div>
    );
  }
}

RightPanel.propTypes = propTypes;
RightPanel.defaultProps = defaultProps;

export default scrollWatcher(RightPanel);



// WEBPACK FOOTER //
// ./src/modules/orders/components/RightPanel/index.jsx